export const GET_WAITING_AREAS = 'GET_WAITING_AREAS';
export const STOPPED_GETTING_WAITING_AREAS = 'STOPPED_GETTING_WAITING_AREAS';
export const STOPPED_GETTING_WAITING_AREA = 'STOPPED_GETTING_WAITING_AREA';
export const GOT_WAITING_AREAS = 'GOT_WAITING_AREAS';
export const UPDATE_WAITING_AREAS = 'UPDATE_WAITING_AREAS';
export const SELECT_WAITING_AREA = 'SELECT_WAITING_AREA';
export const SELECT_WAITING_AREA_ENTITY = 'SELECT_WAITING_AREA_ENTITY';
export const GET_WAITING_AREA = 'GET_WAITING_AREA';
export const GOT_WAITING_AREA = 'GOT_WAITING_AREA';
export const GOT_WAITING_AREA_GC = 'GOT_WAITING_AREA_GC';
export const REMOVE_WAITING_AREA_FROM_REDUCER = 'REMOVE_WAITING_AREA_FROM_REDUCER';
export const UPDATE_FETCHING_WAITING_AREA = 'UPDATE_FETCHING_WAITING_AREA';
export const UPDATE_WAITING_AREAS_PERMISSION = 'UPDATE_WAITING_AREAS_PERMISSION';
export const GET_ORGANISATION_WAITING_AREAS = 'GET_ORGANISATION_WAITING_AREAS';
export const GOT_ORGANISATION_WAITING_AREAS = 'GOT_ORGANISATION_WAITING_AREAS';
export const CLICKED_JOIN_ROOM = 'CLICKED_JOIN_ROOM';
export const UPDATE_WAITING_AREA = 'UPDATE_WAITING_AREA';
export const SUSPEND_ACCESS_WAITING_AREA = 'SUSPEND_ACCESS_WAITING_AREA';
export const RESTORE_ACCESS_WAITING_AREA = 'RESTORE_ACCESS_WAITING_AREA';
export const RESET_WAITING_AREA = 'RESET_WAITING_AREA';
export const ERROR_GETTING_WAITING_AREAS = 'ERROR_GETTING_WAITING_AREAS';
export const ERROR_GETTING_WAITING_AREA = 'ERROR_GETTING_WAITING_AREA';
export const UPDATED_CURRENT_CREATE_WAITING_AREA_STEP = 'UPDATED_CURRENT_CREATE_WAITING_AREA_STEP';
export const RESET_WAITING_AREA_FORM = 'RESET_WAITING_AREA_FORM';
export const UPDATED_CURRENT_FILLED_WAITING_AREA_STEP = 'UPDATED_CURRENT_FILLED_WAITING_AREA_STEP';
export const UPDATED_WAITING_AREA_FORM = 'UPDATED_WAITING_AREA_FORM';
export const UPDATE_WAITING_AREAS_SEARCH = 'UPDATE_WAITING_AREAS_SEARCH';
export const UPDATE_WAITING_AREA_SEARCH = 'UPDATE_WAITING_AREA_SEARCH';
export const UPDATE_INITIATED_CN_WAITING_AREA_SEARCH = 'UPDATE_INITIATED_CN_WAITING_AREA_SEARCH';
export const UPDATE_INPROGRESS_CN_WAITING_AREA_SEARCH = 'UPDATE_INPROGRESS_CN_WAITING_AREA_SEARCH';
export const DISCONNECT_CALLER = 'DISCONNECT_CALLER';
export const CALLER_DISCONNECTED = 'CALLER_DISCONNECTED';
export const GET_ORGANISATIONS_WERE_I_CAN_CREATE_WAITING_AREAS = 'GET_ORGANISATIONS_WERE_I_CAN_CREATE_WAITING_AREAS';
export const GOT_ORGANISATIONS_WERE_I_CAN_CREATE_WAITING_AREAS = 'GOT_ORGANISATIONS_WERE_I_CAN_CREATE_WAITING_AREAS';
export const GOT_WARECORDING_SETTING_FEATURE = 'GOT_WARECORDING_SETTING_FEATURE';

export const GET_WAITING_AREA_WEBSITE_DETAILS = 'GET_WAITING_AREA_WEBSITE_DETAILS';
export const GOT_WAITING_AREA_WEBSITE_DETAILS = 'GOT_WAITING_AREA_WEBSITE_DETAILS';
export const UPDATED_WEBSITE_BUTTON_FORM = 'UPDATED_WEBSITE_BUTTON_FORM';
export const UPDATE_WEBSITE_BUTTON_DETAILS = 'UPDATE_WEBSITE_BUTTON_DETAILS';
export const UPDATED_WEBSITE_BUTTON_DETAILS = 'UPDATED_WEBSITE_BUTTON_DETAILS';
export const ADD_TO_CALL_WAITING_AREA_PARTICIPANT = 'ADD_TO_CALL_WAITING_AREA_PARTICIPANT';
export const ADDED_TO_CALL_WAITING_AREA_PARTICIPANT = 'ADDED_TO_CALL_WAITING_AREA_PARTICIPANT';
export const FAILED_ADDING_TO_CALL_WAITING_AREA_PARTICIPANT = 'FAILED_ADDING_TO_CALL_WAITING_AREA_PARTICIPANT';
export const UPDATE_WAITING_AREA_SMS_NOTIFICATION_FORM = 'UPDATE_WAITING_AREA_SMS_NOTIFICATION_FORM';
export const UPDATE_WAITING_AREA_SMS_NOTIFICATION = 'UPDATE_WAITING_AREA_SMS_NOTIFICATION';
export const UPDATED_WAITING_AREA_SMS_NOTIFICATION = 'UPDATED_WAITING_AREA_SMS_NOTIFICATION';
export const ERROR_UPDATING_WAITING_AREA_SMS_NOTIFICATION = 'ERROR_UPDATING_WAITING_AREA_SMS_NOTIFICATION';
export const RESET_WAITING_AREA_SMS_NOTIFICATION_FORM = 'RESET_WAITING_AREA_SMS_NOTIFICATION_FORM';
export const SET_AUTH_TICKET = 'SET_AUTH_TICKET';
export const SET_VIDYO_ROOM_ID_FOR_CONSULT_NOW = 'SET_VIDYO_ROOM_ID_FOR_CONSULT_NOW';
/////////////////////General Info////////////////////////////////////////////////
export const UPDATED_WAITING_AREA = 'UPDATED_WAITING_AREA';
/////////////////////END General Info////////////////////////////////////////////////

/////////////////////GC waiting area settings////////////////////////////////////////////////
export const GOT_GC_WAITING_AREA_SETTINGS = 'GOT_GC_WAITING_AREA_SETTINGS';
export const MODIFIED_GC_WA_SETTING_FORM = 'MODIFIED_GC_WA_SETTING_FORM';
/////////////////////END GC waiting area settings////////////////////////////////////////////////

/////////////////////Notify Room Participants////////////////////////////////////////////////
export const UPDATE_WAITING_AREA_NOTIFY_ROOM_PARTICIPANTS = 'UPDATE_WAITING_AREA_NOTIFY_ROOM_PARTICIPANTS';
export const UPDATED_WAITING_AREA_NOTIFY_ROOM_PARTICIPANTS = 'UPDATED_WAITING_AREA_NOTIFY_ROOM_PARTICIPANTS';
export const UPDATE_WAITING_AREA_NOTIFY_ROOM_PARTICIPANTS_FORM = 'UPDATE_WAITING_AREA_NOTIFY_ROOM_PARTICIPANTS_FORM';
/////////////////////END Notify Room Participants////////////////////////////////////////////////

///////////////////////////OPERATING HOURS//////////////////////////////////////////////////////
export const GET_WAITING_AREA_OPERATING_HOURS = 'GET_WAITING_AREA_OPERATING_HOURS';
export const GOT_WAITING_AREA_OPERATING_HOURS = 'GOT_WAITING_AREA_OPERATING_HOURS';
export const UPDATE_WAITING_AREA_OPERATING_HOURS_FORM = 'UPDATE_WAITING_AREA_OPERATING_HOURS_FORM';
export const UPDATE_WAITING_AREA_OPERATING_HOURS = 'UPDATE_WAITING_AREA_OPERATING_HOURS';
export const UPDATED_WAITING_AREA_OPERATING_HOURS = 'UPDATED_WAITING_AREA_OPERATING_HOURS';
//////////////////////////End Operating Hours//////////////////////////////////////////////////

///////////////////////////Local Video Call OPERATING HOURS//////////////////////////////////////////////////////
export const GET_WAITING_AREA_LOCAL_ACCESS_HOURS = 'GET_WAITING_AREA_LOCAL_ACCESS_HOURS';
export const GOT_WAITING_AREA_LOCAL_ACCESS_HOURS = 'GOT_WAITING_AREA_LOCAL_ACCESS_HOURS';
export const UPDATE_WAITING_AREA_LOCAL_ACCESS_HOURS_FORM = 'UPDATE_WAITING_AREA_LOCAL_ACCESS_HOURS_FORM';
export const UPDATE_WAITING_AREA_LOCAL_ACCESS_HOURS = 'UPDATE_WAITING_AREA_LOCAL_ACCESS_HOURS';
export const UPDATED_WAITING_AREA_LOCAL_ACCESS_HOURS = 'UPDATED_WAITING_AREA_LOCAL_ACCESS_HOURS';
//////////////////////////End Local Video Call  Operating Hours//////////////////////////////////////////////////

///////////////////////////LOGO PAUSE IMAGE//////////////////////////////////////////////////////
export const GET_WAITING_AREA_LOGO_PAUSE_IMAGE = 'GET_WAITING_AREA_LOGO_PAUSE_IMAGE';
export const GOT_WAITING_AREA_LOGO_PAUSE_IMAGE = 'GOT_WAITING_AREA_LOGO_PAUSE_IMAGE';
export const UPDATE_WAITING_AREA_LOGO_PAUSE_IMAGE_FORM = 'UPDATE_WAITING_AREA_LOGO_PAUSE_IMAGE_FORM';
export const UPDATE_WAITING_AREA_LOGO_PAUSE_IMAGE = 'UPDATE_WAITING_AREA_LOGO_PAUSE_IMAGE';
export const UPDATED_WAITING_AREA_LOGO_PAUSE_IMAGE = 'UPDATED_WAITING_AREA_LOGO_PAUSE_IMAGE';
///////////////////////////END LOGO PAUSE IMAGE//////////////////////////////////////////////////

export const UPDATE_VIDEO_SETTINGS_FOR_PROVIDER = 'UPDATE_VIDEO_SETTINGS_FOR_PROVIDER';
export const UPDATED_VIDEO_SETTINGS_FOR_PROVIDER = 'UPDATED_VIDEO_SETTINGS_FOR_PROVIDER';

export const UPDATE_MICROPHONE_SETTINGS_FOR_PROVIDER = 'UPDATE_MICROPHONE_SETTINGS_FOR_PROVIDER';
export const UPDATED_MICROPHONE_SETTINGS_FOR_PROVIDER = 'UPDATED_MICROPHONE_SETTINGS_FOR_PROVIDER';

export const UPDATED_SHOW_SUSPEND_WA_MODAL = 'UPDATE_SHOW_SUSPEND_WA_MODAL';

//Before calls
export const GOT_WAITING_AREA_BEFORE_CALLS = 'GOT_WAITING_AREA_BEFORE_CALLS';
export const MODIFIED_BEFORE_CALLS_FORM = 'MODIFIED_BEFORE_CALLS_FORM';
export const UPDATE_WAITING_AREA_MEMBER_SEARCH = 'UPDATE_WAITING_AREA_MEMBER_SEARCH';

// Before Calls Important Information
export const GOT_WAITING_AREA_BEFORE_CALLS_IMPORTANT_INFO = 'GOT_WAITING_AREA_BEFORE_CALLS_IMPORTANT_INFO';
export const MODIFIED_BEFORE_CALLS_IMPORTANT_INFO_FORM = 'MODIFIED_BEFORE_CALLS_IMPORTANT_INFO_FORM';

// Caller Entry Point
export const UPDATE_CALLER_ENTRY_POINT_FORM = 'UPDATE_CALLER_ENTRY_POINT_FORM';
export const MODIFIED_CALLER_ENTRY_POINT_FORM = 'MODIFIED_CALLER_ENTRY_POINT_FORM';
export const CALLER_ENTRY_POINT_URL_IN_USE = 'CALLER_ENTRY_POINT_URL_IN_USE';

// During calls
export const UPDATE_DURING_CALLS_FORM = 'UPDATE_DURING_CALLS_FORM';
export const MODIFIED_DURING_CALLS_FORM = 'MODIFIED_DURING_CALLS_FORM';
export const UPDATE_IS_RECORDING_AVAILABLE_ON_PORTAL = 'UPDATE_IS_RECORDING_AVAILABLE_ON_PORTAL';
export const SET_CALL_QUALITY_PROFILE = 'SET_CALL_QUALITY_PROFILE';

//After calls
export const GOT_WAITING_AREA_AFTER_CALLS = 'GOT_WAITING_AREA_AFTER_CALLS';
export const MODIFIED_AFTER_CALLS_FORM = 'MODIFIED_AFTER_CALLS_FORM';

// Call history
export const UPDATE_WA_CALL_HISTORY = 'UPDATE_WA_CALL_HISTORY';

/////////////Self Privision Create WA ORG
export const VALIDATE_SELF_PROVISION_TOKEN = 'VALIDATE_SELF_PROVISION_TOKEN';

export const SET_WA_SELF_PROVISION_FORM = 'SET_REGISTER_USER_WA_FORM';
export const SET_WA_SELF_PROVISION_FORM_TRIM = 'SET_WA_SELF_PROVISION_FORM_TRIM';
export const RESET_WA_SELF_PROVISION_FORM = 'RESET_WA_SELF_PROVISION_FORM';
export const SET_REGISTER_USER_WA_TOKEN = 'SET_REGISTER_USER_WA_TOKEN';

/////////////End Self Provision Create WA ORG

////CREATE WA
export const SET_CREATE_WA_FORM = 'SET_CREATE_WA_FORM';
export const SET_CREATE_WA_FORM_TRIM = 'SET_CREATE_WA_FORM_TRIM';

export const RESET_CREATE_WA_FORM = 'RESET_CREATE_WA_FORM';
////END CREATE WA

//Manage roles for users list
export const GOT_AVAILABLE_ROLES_FOR_WAITING_AREA = 'GOT_AVAILABLE_ROLES_FOR_WAITING_AREA';
export const UPDATE_SELECTED_USER_FOR_MANAGEMENT = 'UPDATE_SELECTED_USER_FOR_MANAGEMENT';
export const UPDATE_ROLES_FOR_SELECTED_USER_IN_MANAGE_USERS_PAGE =
  'UPDATE_ROLES_FOR_SELECTED_USER_IN_MANAGE_USERS_PAGE';

export const ADD_USERS_FORM = {
  SELECT_ROLE: 'ADD_USERS_FORM.SELECT_ROLE',
  UNSELECT_ROLE: 'ADD_USERS_FORM.UNSELECT_ROLE',
  UPDATE_MESSAGE: 'ADD_USERS_FORM.UPDATE_MESSAGE',
  CLEAR_FORM: 'ADD_USERS_FORM.CLEAR_FORM',
  ADDING_USERS_TO_WAITING_AREA: 'ADD_USERS_FORM.ADDING_USERS_TO_WAITING_AREA',
};

// Suppport Contact
export const SUPPORT_CONTACT = {
  GOT_INFO: 'GOT_INFO',
  RESET_SUPPORT_CONTACT: 'RESET_SUPPORT_CONTACT',
  CHANGE_SUPPORT_CONTACT_INFO: 'CHANGE_SUPPORT_CONTACT_INFO',
};

// Share link to WA message
export const GOT_WAITING_AREA_SHARE_LINK_MESSAGE = 'GOT_WAITING_AREA_SHARE_LINK_MESSAGE';

// Information for Callers
export const GOT_WAITING_AREA_INFORMATION_FOR_CALLERS = 'GOT_WAITING_AREA_INFORMATION_FOR_CALLERS';
export const CHANGE_WAITING_AREA_INFORMATION_FOR_CALLERS = 'CHANGE_WAITING_AREA_INFORMATION_FOR_CALLERS';
export const WAITING_AREA_INFORMATION_FILE_SIZE_EXCEED = 'WAITING_AREA_INFORMATION_FILE_SIZE_EXCEED';

export const WAITING_AREA_TAGS = {
  GOT_TAGS: 'WAITING_AREA.GOT_TAGS',
  ERROR_GETTING_TAGS: 'WAITING_AREA.ERROR_GETTING_TAGS',
  UPDATE_SEARCH_TERM: 'WAITING_AREA_TAGS.UPDATE_SEARCH_TERM',
  GOT_AVAILABLE_TAGS_BY_NETWORKID: 'WAITING_AREA.GOT_AVAILABLE_TAGS_BY_NETWORKID',
  GOT_AVAILABLE_TAGS_BY_TAGID: 'WAITING_AREA.GOT_AVAILABLE_TAGS_BY_TAGID',
  ERROR_GETTING_AVAILABLE_TAGS_BY_NETWORKID: 'WAITING_AREA.ERROR_GETTING_AVAILABLE_TAGS_BY_NETWORKID',
  CLEAR_TEMP_AVAILABLE_TAGS_OBJECT: 'WAITING_AREA.CLEAR_TEMP_AVAILABLE_TAGS_OBJECT',
  UPDATE_SELECTED_TAG_FOR_MANAGEMENT: 'WAITING_AREA.UPDATE_SELECTED_TAG_FOR_MANAGEMENT',
  UPDATE_ASSIGN_TAG_VALUES_FORM: 'WAITING_AREA.UPDATE_ASSIGN_TAG_VALUES_FORM',
  CLEAR_TEMP_ASSIGN_TAGS_OBJECT: 'WAITING_AREA.CLEAR_TEMP_ASSIGN_TAGS_OBJECT',
};

// Advanced Menu
export const SHOW_ADVANCED_MENU = 'SHOW_ADVANCED_MENU';

// Participants' workflow
export const UPDATE_SELECTED_PARTICIPANT_FORM_IN_WA = 'UPDATE_SELECTED_PARTICIPANT_FORM_IN_WA';
export const UPDATE_SELECTED_VIDEO_CALL_ROOM = 'UPDATE_SELECTED_VIDEO_CALL_ROOM';
export const UPDATE_SELECTED_VIDEO_CALL_ROOM_ID = 'UPDATE_SELECTED_VIDEO_CALL_ROOM_ID';

export const WAITING_AREAS_NEED_TO_UPDATE = 'WAITING_AREAS_NEED_TO_UPDATE';

// Update WA is open or not
export const UPDATE_WA_IS_OPEN_OR_CLOSED = 'UPDATE_WA_IS_OPEN_OR_CLOSED';
// WA room details
export const SET_WAITING_AREA_ROOM_AND_PARTICIPANTS = 'SET_WAITING_AREA_ROOM_AND_PARTICIPANTS';
export const SET_WAITING_AREA_ROOM_AND_PARTICIPANTS_GC = 'SET_WAITING_AREA_ROOM_AND_PARTICIPANTS_GC';
export const SET_CALL_SUMMARY_BY_ID = 'SET_CALL_SUMMARY_BY_ID';

// Get Email / SMS template
export const SET_WA_URL_EMAIL_TEMPLATE = 'SET_WA_URL_EMAIL_TEMPLATE';
export const SET_WA_URL_TEXT_TEMPLATE = 'SET_WA_URL_TEXT_TEMPLATE';

// Consult Now
export const GOT_CONSULT_NOW_INITIATED_CALLS = 'GOT_CONSULT_NOW_INITIATED_CALLS';
export const UPDATE_SELECTED_CONSULT_NOW_CALLER = 'UPDATE_SELECTED_CONSULT_NOW_CALLER';
export const SET_CONSULT_NOW_AUTH_TICKET = 'SET_CONSULT_NOW_AUTH_TICKET';

import { displayGlobalMessage } from '../actions/globalMessage';
import {
  showWaitingAreaLogoPauseImageModal,
  showHideWaitingAreaAddUsersModal,
  showShowCallHistoryModal,
} from '../actions/modal';
import fc from '../businessLogic/fetchInterceptor';
import { getAuthHeaders } from '../businessLogic/authorizator';
import { queueESEvents, ESEventTypes } from 'businessLogic/logEventToElasticSearch';
import { getWaitingAreaUsers, SEARCH_SELECT_USERS_FORM } from './user.js';
import { CONSULT_NOW_TOGGLE } from './shared';
import { unSubscribPubnubChannels } from './pubnub/init';
import { NetworkTypes } from '../constants/networkTypes.js';
export function waitingareasNeedToUpdate(isWaitingAreasUpToDate) {
  // If isWaitingAresUpToDate == false, means waiting area lists are not update to date
  // Requires Lazy load for waiting areas if they are accessing for the resources later
  return (dispatch) => {
    dispatch({
      type: WAITING_AREAS_NEED_TO_UPDATE,
      data: isWaitingAreasUpToDate,
    });
  };
}

export function updateWAsWhenRequire(userProfile, cb) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_WAITING_AREAS,
      data: userProfile,
    });
  };
}

export function checkUpdatesForDirectAssociatedWAs(data) {
  return (dispatch) => {
    let userProfile = data;
    let locationOfPage = window.location.href.split('?')[0] || window.location.href;

    let isOnManageUserPage = locationOfPage.indexOf('/manage-users/') > -1;
    if (
      userProfile &&
      userProfile.hasEntityAdminRights &&
      userProfile.hasEntityAdminRights.isOrgAdmin &&
      userProfile.shouldLoadDirectlyAssociatedWAs &&
      !isOnManageUserPage
    ) {
      let currentWAs = window.getState().waitingAreaReducer.waitingAreas.map((wa) => wa.id);
      let waitingAreaDA = userProfile.waitingAreasDirectlyAssociated.map((wa) => wa.id);

      if (locationOfPage.indexOf('/waiting-area/view-all') > -1) {
        // for those WAs not directly associated anymore
        dispatch(updateWAsWhenRequire(userProfile));
        if (currentWAs.length < waitingAreaDA.length) {
          let addWaitingArea = waitingAreaDA.filter((x) => !currentWAs.includes(x));
          addWaitingArea.map((wa) => {
            queueESEvents(
              ESEventTypes.APICall,
              `In checkUpdatesForDirectAssociatedWAs else block(due to pubnub to trigger basicinfo update): ${wa}`,
              'eventType&apiURL',
              {
                apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + wa + '/calls',
                browserURL: window.location.href,
              },
              null,
              true,
              'info'
            );
            dispatch(getWaitingArea(wa));
          });
        }
      } else {
        waitingareasNeedToUpdate(false);
      }
    }
  };
}

export function getWaitingAreas(cb) {
  return (dispatch) => {
    let mandatoryCallback = (actionToDispatch) => {
      return actionToDispatch;
    };
    let errorCallback = (response) => {
      console.error(response);
      dispatch({ type: ERROR_GETTING_WAITING_AREAS });
    };
    dispatch({ type: GET_WAITING_AREAS });

    fc.get(window.APP.CONFIGURATION.VCCAPI + 'waitingareas' + '/calls')
      .then((data) => {
        if (cb) cb(data);
        const userProfile = window.getState().usersReducer.userProfile;
        return dispatch({
          type: GOT_WAITING_AREAS,
          data: data,
          userProfile,
        });
      })
      .catch((err) => errorCallback(err));
  };
}

///////This function has been written to be used by written test. it will populate the waitingareas queue with the provided WA lists
export function gotWaitingAreasForUnitTest(waitingAreas) {
  return (dispatch) => {
    return dispatch({ type: GOT_WAITING_AREAS, data: waitingAreas });
  };
}

export function getOrganisationWaitingAreas(orgName, cb) {
  var waitingAreaData = [
    {
      id: 1,
      name: 'Brisbane North PHN',
      organisationName: 'AA Test Organisation',
      organisationAbbreviatedName: 'AA Test Org',
      enteryPage: window.APP.CONFIGURATION.VCCAPI + 'start/?apikey=408F3534-F44E-4750-AE43-FE4EAE16306A',
    },
    {
      id: 2,
      name: 'Barwon South West Telehealth',
      organisationName: 'AA Test Organisation',
      organisationAbbreviatedName: 'AA Test Org',
      enteryPage: window.APP.CONFIGURATION.VCCAPI + 'start/?apikey=CDA17AB8-BA52-4033-9939-5955C27830E0',
    },
    {
      id: 3,
      name: 'Connect to Liesl (LCD)',
      organisationName: 'AA Test Organisation',
      organisationAbbreviatedName: 'AA Test Org',
      enteryPage: window.APP.CONFIGURATION.VCCAPI + 'start/?apikey=CDA17AB8-BA52-4033-9939-5955C27830E0',
    },
    {
      id: 4,
      name: 'Barwon South West Telehealth',
      organisationName: 'AA Test Organisation',
      organisationAbbreviatedName: 'AA Test Org',
      enteryPage: window.APP.CONFIGURATION.VCCAPI + 'start/?apikey=AC51749E-020C-4D23-B305-00A95D48C600',
    },
    {
      id: 5,
      name: 'Dr Christine Somerville (BH Renal Medicine)',
      organisationName: 'AA Test Organisation',
      organisationAbbreviatedName: 'AA Test Org',
      enteryPage: window.APP.CONFIGURATION.VCCAPI + 'start/?apikey=CDA17AB8-BA52-4033-9939-5955C27830E0',
    },
    {
      id: 6,
      name: 'Dr Givney Nursing Home Telehealth Clinic (SESLHD Integr. Care)',
      organisationName: 'AA Test Organisation',
      organisationAbbreviatedName: 'AA Test Org',
      enteryPage: window.APP.CONFIGURATION.VCCAPI + 'start/?apikey=AC51749E-020C-4D23-B305-00A95D48C600',
    },
    {
      id: 7,
      name: 'Barwon South West Telehealth',
      organisationName: 'AA Test Organisation',
      organisationAbbreviatedName: 'AA Test Org',
      enteryPage: window.APP.CONFIGURATION.VCCAPI + 'start/?apikey=AC51749E-020C-4D23-B305-00A95D48C600',
    },
    {
      id: 8,
      name: 'Dr Christine Somerville (BH Renal Medicine)',
      organisationName: 'AA Test Organisation',
      organisationAbbreviatedName: 'AA Test Org',
      enteryPage: window.APP.CONFIGURATION.VCCAPI + 'start/?apikey=CDA17AB8-BA52-4033-9939-5955C27830E0',
    },
    {
      id: 9,
      name: 'Dr Givney Nursing Home Telehealth Clinic (SESLHD Integr. Care)',
      organisationName: 'AA Test Organisation',
      organisationAbbreviatedName: 'AA Test Org',
      enteryPage: window.APP.CONFIGURATION.VCCAPI + 'start/?apikey=AC51749E-020C-4D23-B305-00A95D48C600',
    },
    {
      id: 10,
      name: 'Barwon South West Telehealth',
      organisationName: 'AA Test Organisation',
      organisationAbbreviatedName: 'AA Test Org',
      enteryPage: window.APP.CONFIGURATION.VCCAPI + 'start/?apikey=AC51749E-020C-4D23-B305-00A95D48C600',
    },
  ];
  return (dispatch) => {
    dispatch({ type: GET_ORGANISATION_WAITING_AREAS });
    setTimeout(() => {
      dispatch({ type: GOT_ORGANISATION_WAITING_AREAS, data: waitingAreaData });
      if (cb) cb();
    }, 500);
  };
}

// Get data for General Info dialog
export function getWaitingAreaGeneralInfo(waitingAreaId, cb) {
  return (dispatch) => {
    fc.get(`${window.APP.CONFIGURATION.VCCAPI}waitingareas/${waitingAreaId}/generalinfo`)
      .then((data) => {
        data.id = waitingAreaId;
        if (cb) {
          cb(data);
        }
      })
      .catch((err) => console.error('There was an error getting the general info for waiting areas', err.toString()));
  };
}

export function updateWaitingAreaGeneralInfo(waitingArea, cb) {
  return (dispatch) => {
    fc.put(window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingArea.id + '/generalInfo', {
      body: JSON.stringify(waitingArea),
    })
      .then((response) => {
        var successMessage = APP.LANGUAGE.WaitingAreaGeneralInfo.SuccessUpdateMessage;
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        dispatch({ type: UPDATED_WAITING_AREA, data: waitingArea });
        if (cb) cb(true);
      })
      .catch((err, resp) => {
        console.error('There was an API error', err.toString());
        if (cb) cb(false);
      });
  };
}

export function resetWaitingAreaForm() {
  return (dispatch) => {
    return dispatch({ type: RESET_WAITING_AREA_FORM });
  };
}

export function updateCurrentFilledWaitingAreaStep(step) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_CURRENT_FILLED_WAITING_AREA_STEP,
      data: step,
    });
  };
}

export function updateCurrentCreateWaitingAreaStep(step) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_CURRENT_CREATE_WAITING_AREA_STEP,
      data: step,
    });
  };
}

export function updateWaitingAreaForm(waitingAreaModified) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_WAITING_AREA_FORM,
      data: waitingAreaModified,
    });
  };
}

export function selectWaitingArea(waitingAreaId, cb) {
  return (dispatch) => {
    return dispatch({ type: SELECT_WAITING_AREA, data: waitingAreaId });
  };
}

export function selectWaitingAreaEntity(waitingArea, cb) {
  return (dispatch) => {
    return dispatch({ type: SELECT_WAITING_AREA_ENTITY, data: waitingArea });
  };
}

export function removeWAFromReduer(waitingAreaId) {
  return (dispatch) => {
    return dispatch({
      type: REMOVE_WAITING_AREA_FROM_REDUCER,
      data: waitingAreaId,
    });
  };
}

export function getWaitingArea(waitingAreaId, cb, errorCb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_GETTING_WAITING_AREA });
      dispatch({ type: UPDATE_FETCHING_WAITING_AREA, data: false });
      // For now, this is for pubnub updates
      if (errorCb) errorCb(response, waitingAreaId);
    };

    fc.get(window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingAreaId + '/calls')
      .then((data) => {
        if (cb) cb(data);
        if (data) {
          dispatch({
            // Keeping separate for GC WA as data will be manipulated differently where we will make virtual rooms
            // as there will be always single room with list of participants with their statuses
            type: data.networkTypeId === NetworkTypes.GroupConsultation ? GOT_WAITING_AREA_GC : GOT_WAITING_AREA,
            data: data,
            waitingAreaId: waitingAreaId,
          });
          return;
        } else {
          console.log('empty wa data', data);
        }
      })
      .catch((err, resp) => {
        console.error('There was an API error', err.toString());
        errorCallback(err);
      });
  };
}

export function updateFetchingWA(isFetching) {
  return (dispatch) => {
    return dispatch({ type: UPDATE_FETCHING_WAITING_AREA, data: isFetching });
  };
}

export function clickedJoinRoom() {
  return (dispatch) => {
    return dispatch({ type: CLICKED_JOIN_ROOM });
  };
}

export function disconnectCaller(vidyoCallId, callerName, cb) {
  return (dispatch) => {
    dispatch({ type: DISCONNECT_CALLER, data: vidyoCallId });
    fc.put(window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + vidyoCallId + '/disconnectCaller')
      .then((response) => {
        var successMessage = APP.LANGUAGE.ViewOneWaitingArea.DisconnectSuccess.replace('##callerName##', callerName);
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        dispatch({ type: CALLER_DISCONNECTED, data: vidyoCallId });
        if (cb) cb(true);
      })
      .catch((err, resp) => {
        console.error('There was an API error', err.toString());
        if (cb) cb(false);
      });
  };
}

export function updateWaitingAreasSearch(searchTerm) {
  return (dispatch) => {
    dispatch({ type: UPDATE_WAITING_AREAS_SEARCH, data: searchTerm });
  };
}

export function updateWaitingAreaSearch(searchTerm) {
  return (dispatch) => {
    dispatch({ type: UPDATE_WAITING_AREA_SEARCH, data: searchTerm });
  };
}

export function updateInitiatedCNWaitingAreaSearch(searchTerm) {
  return (dispatch) => {
    dispatch({ type: UPDATE_INITIATED_CN_WAITING_AREA_SEARCH, data: searchTerm });
  };
}

export function updateInprogressCNWaitingAreaSearch(searchTerm) {
  return (dispatch) => {
    dispatch({ type: UPDATE_INPROGRESS_CN_WAITING_AREA_SEARCH, data: searchTerm });
  };
}

export function updateWaitingAreaMemberSearch(searchTerm) {
  return (dispatch) => {
    dispatch({ type: UPDATE_WAITING_AREA_MEMBER_SEARCH, data: searchTerm });
  };
}

export function resetWaitingArea() {
  return (dispatch) => {
    return dispatch({ type: RESET_WAITING_AREA });
  };
}

export function suspendAccessWaitingArea(waitingArea, suspendMsgBody, callback) {
  return (dispatch) => {
    fc.put(window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingArea.id + '/suspendaccess', {
      body: JSON.stringify(suspendMsgBody),
    })
      .then((response) => {
        dispatch({ type: SUSPEND_ACCESS_WAITING_AREA, data: waitingArea.id });
        var successMessage = APP.LANGUAGE.ViewOneWaitingArea.SuspendAccessSuccess.replace(
          '##waitingAreaName##',
          waitingArea.name
        );
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        if (callback) callback(false);
      })
      .catch((err, resp) => {
        console.error('There was an API error', err.toString());
        var errorMsg = APP.LANGUAGE.SuspendWaitingAreaModal.UnableToSuspendErrorMsg.replace(
          '##waitingAreaName##',
          waitingArea.name
        );
        if (err === 'ConsultNowCallsPending') {
          dispatch(
            displayGlobalMessage({
              text: errorMsg,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: true,
            })
          );
        }
        if (callback) callback(true);
      });
  };
}

export function restoreAccessWaitingArea(waitingArea, cb) {
  return (dispatch) => {
    fc.put(window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingArea.id + '/restoreaccess')
      .then((response) => {
        dispatch({ type: RESTORE_ACCESS_WAITING_AREA, data: waitingArea.id });
        var successMessage = APP.LANGUAGE.ViewOneWaitingArea.RestoreAccessSuccess.replace(
          '##waitingAreaName##',
          waitingArea.name
        );
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        if (cb) cb();
      })
      .catch((err, resp) => {
        console.error('There was an API error', err.toString());
      });
  };
}

export function getOrganisationsWereIcanCreateWaitingAreas(cb) {
  if (window.hideUnfinishedItems) {
    //we return empty array for the case of P2
    return (dispatch) => {
      dispatch({ type: GET_ORGANISATIONS_WERE_I_CAN_CREATE_WAITING_AREAS });
      setTimeout(() => {
        dispatch({
          type: GOT_ORGANISATIONS_WERE_I_CAN_CREATE_WAITING_AREAS,
          data: [],
        });
        if (cb) cb();
      }, 500);
    };
  } else {
    return (dispatch) => {
      dispatch({ type: GET_ORGANISATIONS_WERE_I_CAN_CREATE_WAITING_AREAS });
      var apiPart = 'organisations/CREATE_WAITING_AREA';
      fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
        .then((data) => {
          if (cb) cb();
          let res = dispatch({
            type: GOT_ORGANISATIONS_WERE_I_CAN_CREATE_WAITING_AREAS,
            data: data,
          });
          return res;
        })
        .catch((err) => console.error('There was an error getOrganisationsWereIcanCreateWaitingAreas', err.toString()));
    };
  }
}
export function getWebsiteButtonDetails(waitingAreaId, cb) {
  return (dispatch) => {
    dispatch({ type: GET_WAITING_AREA_WEBSITE_DETAILS });
    var apiPart = 'waitingareas/' + waitingAreaId + '/websiteButton';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        if (cb) cb();
        let res = dispatch({
          type: GOT_WAITING_AREA_WEBSITE_DETAILS,
          data: data,
        });
        return res;
      })
      .catch((err) => console.error('There was an error getting the waiting areas', err.toString()));
  };
}

export function updateWebsiteButtonForm(websiteButtonModified) {
  return (dispatch) => {
    return dispatch({
      type: UPDATED_WEBSITE_BUTTON_FORM,
      data: websiteButtonModified,
    });
  };
}

export function updateWebsiteButton(orgWebsiteButtonDetails, cb) {
  return (dispatch) => {
    dispatch({ type: UPDATE_WEBSITE_BUTTON_DETAILS });
    fc.post(window.APP.CONFIGURATION.VCCAPI + 'waitingareas/webButtonDetails', {
      body: JSON.stringify(orgWebsiteButtonDetails),
    })
      .then((data) => {
        if (cb) cb();
        dispatch({
          type: UPDATED_WEBSITE_BUTTON_DETAILS,
          data: orgWebsiteButtonDetails,
        });
        var successMessage = APP.LANGUAGE.CreateWaitingAreaWebsiteButton.CreateWaitingAreaWebsiteButtonSuccess;
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        dispatch({ type: UPDATED_WEBSITE_BUTTON_DETAILS }); //TODO: should use organisation specific reset fetching flag
        console.error('There was an API error', err.toString());
      });
  };
}

export function addToCallWaitingAreaParticipant(mainParticipant, cb) {
  return (dispatch) => {
    dispatch({ type: ADD_TO_CALL_WAITING_AREA_PARTICIPANT });
    //   fc.put(window.APP.CONFIGURATION.VCCAPI + "waitingareas/" + waitingArea.id + "/suspendaccess").then(response => {
    fc.put(window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + mainParticipant.id + '/addToCall')
      .then((data) => {
        if (cb) cb(data);
        if (data === false) {
          //Error in adding the caller
          dispatch({ type: FAILED_ADDING_TO_CALL_WAITING_AREA_PARTICIPANT });
          var failureMessage = APP.LANGUAGE.AddToCallWaitingArea.FailureMessage.replace(
            '##userName##',
            mainParticipant.name
          );
          dispatch(
            displayGlobalMessage({
              text: failureMessage,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: false,
              apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + mainParticipant.id + '/addToCall',
              browserURL: window.location.href,
            })
          );
        } else {
          //SUCCESSFULLY ADDED
          dispatch({
            type: ADDED_TO_CALL_WAITING_AREA_PARTICIPANT,
            data: mainParticipant,
          });
          var successMessage = APP.LANGUAGE.AddToCallWaitingArea.SuccessMessage.replace(
            '##userName##',
            mainParticipant.name
          );
          dispatch(
            displayGlobalMessage({
              text: successMessage,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
              autoHide: true,
            })
          );
        }
      })
      .catch((err, resp) => {
        cb(false); //there was some exception
        dispatch({ type: FAILED_ADDING_TO_CALL_WAITING_AREA_PARTICIPANT }); //TODO: should use organisation specific reset fetching flag
        console.error('There was an API error', err.toString());
      });
  };
}

export function updateVideoSettingsForProvider(waitingAreaId, isOn, cb) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_VIDEO_SETTINGS_FOR_PROVIDER,
      data: { isCameraOn: isOn },
    });
    fc.put(window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingAreaId + '/UpdateCameraDisplaySetting', {
      body: JSON.stringify({ value: isOn }),
    })
      .then((data) => {
        if (cb) cb();
        dispatch({
          type: UPDATED_VIDEO_SETTINGS_FOR_PROVIDER,
          data: { isCameraOn: isOn },
        });
      })
      .catch((err, resp) => {
        dispatch({ type: UPDATED_VIDEO_SETTINGS_FOR_PROVIDER }); //TODO: should use organisation specific reset fetching flag
        console.error('There was an API error', err.toString());
      });
  };
}

export function updateMicrophoneSettingsForProvider(waitingAreaId, isOn, cb) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_MICROPHONE_SETTINGS_FOR_PROVIDER,
      data: { isMicrophoneOn: isOn },
    });
    fc.put(window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingAreaId + '/UpdateMicSetting', {
      body: JSON.stringify({ value: isOn }),
    })
      .then((data) => {
        if (cb) cb();
        dispatch({
          type: UPDATED_MICROPHONE_SETTINGS_FOR_PROVIDER,
          data: { isMicrophoneOn: isOn },
        });
      })
      .catch((err, resp) => {
        dispatch({ type: UPDATED_MICROPHONE_SETTINGS_FOR_PROVIDER }); //TODO: should use organisation specific reset fetching flag
        console.error('There was an API error', err.toString());
      });
  };
}
/////////////////////////////NOTIFy ROOM PARTICIPANTS////////////////////////////////////////////////////////////////////////////////
export function updateWaitingAreaNotifyRoomParticipantsForm(updatedForm) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_WAITING_AREA_NOTIFY_ROOM_PARTICIPANTS_FORM,
      data: { message: updatedForm },
    });
  };
}

export function updateWaitingAreaNotifyRoomParticipants(participantRoomData, notifyRoomParticipantsForm, cb) {
  // meeting room; number; content
  return (dispatch) => {
    let apiParam = 'waitingareas/' + participantRoomData.id + '/notifyRoomParticipant';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(notifyRoomParticipantsForm),
    })
      .then((res) => {
        if (cb) cb(res);
      })
      .catch((err) => {
        if (cb) cb(false);
        console.error('There was an API error', err.toString());
      });
  };
}
///////////////////////////END NOTIFy ROOM PARTICIPANTS////////////////////////////////////////////////////////////////////////////////

export function resetWaitingAreaSmsNotificationForm() {
  return (dispatch) => {
    dispatch({ type: RESET_WAITING_AREA_SMS_NOTIFICATION_FORM });
  };
}

export function updateWaitingAreaSmsNotificationForm(updatedForm) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_WAITING_AREA_SMS_NOTIFICATION_FORM,
      data: updatedForm,
    });
  };
}

export function updateWaitingAreaSmsNotification(waitingAreaId, waitingAreaSmsNotificationForm, cb) {
  // meeting room; number; content
  return (dispatch) => {
    dispatch({ type: UPDATE_WAITING_AREA_SMS_NOTIFICATION });
    if (
      waitingAreaSmsNotificationForm.secondsIntervalToSmsSendNotification != 0 &&
      waitingAreaSmsNotificationForm.secondsIntervalToSmsSendNotification != null
    )
      waitingAreaSmsNotificationForm.secondsIntervalToSmsSendNotification =
        waitingAreaSmsNotificationForm.secondsIntervalToSmsSendNotification * 60; //this is here because the server takes seconds not minutes, but the ui displays minutes
    let apiParam = 'waitingareas/' + waitingAreaId + '/updateNotificationSms';
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(waitingAreaSmsNotificationForm),
    })
      .then((res) => {
        if (res == true) {
          let successMessage = APP.LANGUAGE.SuccessUpdatingSms;
          if (cb) cb();
          if (
            waitingAreaSmsNotificationForm.secondsIntervalToSmsSendNotification != 0 &&
            waitingAreaSmsNotificationForm.secondsIntervalToSmsSendNotification != null
          )
            waitingAreaSmsNotificationForm.secondsIntervalToSmsSendNotification =
              waitingAreaSmsNotificationForm.secondsIntervalToSmsSendNotification / 60; //this is here because the server takes seconds not minutes, but the ui displays minutes
          dispatch({
            type: UPDATED_WAITING_AREA_SMS_NOTIFICATION,
            data: waitingAreaSmsNotificationForm,
          });
          dispatch(
            displayGlobalMessage({
              text: successMessage,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
              autoHide: true,
            })
          );
        } else {
          dispatch({ type: ERROR_UPDATING_WAITING_AREA_SMS_NOTIFICATION });
          console.error('get api error from updating sms notification:', res);
        }
      })
      .catch((err) => {
        dispatch({ type: ERROR_UPDATING_WAITING_AREA_SMS_NOTIFICATION });
        console.error('There was an API error', err.toString());
      });
  };
}

// Before calls
export function updateBeforeCallsForm(beforeCallsFormModified) {
  return (dispatch) => {
    return dispatch({
      type: MODIFIED_BEFORE_CALLS_FORM,
      data: beforeCallsFormModified,
    });
  };
}

// Before calls - Important Info
export function updateBeforeCallsImportantInfoForm(value, showCharLimitWarning, ifTextEmpty) {
  console.log('>>>> updateBeforeCallsImportantInfoForm reducer called', value);
  return (dispatch) => {
    return dispatch({
      type: MODIFIED_BEFORE_CALLS_IMPORTANT_INFO_FORM,
      data: {
        value: value,
        showCharLimitWarning: showCharLimitWarning,
        ifTextEmpty: ifTextEmpty,
      },
    });
  };
}

export function getBeforeCallsInfo(waitingAreaId, cb) {
  return (dispatch) => {
    fc.get(`${window.APP.CONFIGURATION.VCCAPI}waitingareas/${waitingAreaId}/beforecalls`)
      .then((data) => {
        let res = dispatch({ type: GOT_WAITING_AREA_BEFORE_CALLS, data: data });
        if (cb) {
          cb();
        }
        return res;
      })
      .catch((err) => console.error('There was an error getting the waiting areas', err.toString()));
  };
}

export function updateBeforeCallDetail(waitingAreaId, beforeCallDetail, cb) {
  return (dispatch) => {
    fc.put(`${window.APP.CONFIGURATION.VCCAPI}waitingareas/${waitingAreaId}/beforecalls`, {
      body: JSON.stringify(beforeCallDetail),
    })
      .then((data) => {
        if (cb) {
          cb();
        }
        let successMessage = APP.LANGUAGE.WaitingAreaBeforeCallsCallers.SuccessfulMessage;
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        console.error('There was an API error', err.toString());
        if (cb) {
          cb();
        }
      });
  };
}

export function getBeforeCallsImportantInfo(waitingAreaId, cb) {
  return (dispatch) => {
    fc.get(`${window.APP.CONFIGURATION.VCCAPI}waitingareas/${waitingAreaId}/beforecalls/importantinfo`)
      .then((data) => {
        let res = dispatch({
          type: GOT_WAITING_AREA_BEFORE_CALLS_IMPORTANT_INFO,
          data: data,
        });
        if (cb) {
          cb();
        }
        return res;
      })
      .catch((err) => console.error('There was an error getting the waiting areas', err.toString()));
  };
}

export function updateBeforeCallsImportantInfo(waitingAreaId, beforeCallDetailValue, cb) {
  return (dispatch) => {
    fc.put(`${window.APP.CONFIGURATION.VCCAPI}waitingareas/${waitingAreaId}/beforecalls/importantinfo`, {
      body: JSON.stringify(beforeCallDetailValue),
    })
      .then((data) => {
        if (cb) {
          cb(true);
        }

        let successMessage = APP.LANGUAGE.WaitingAreaBeforeCallsImportantInfo.SuccessfulMessage;
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        console.error('There was an API error', err.toString());
        if (cb) {
          cb(false);
        }
      });
  };
}

// During calls
export function getDuringCallsInfo(waitingAreaId, cb) {
  return (dispatch) => {
    fc.get(`${window.APP.CONFIGURATION.VCCAPI}waitingareas/${waitingAreaId}/duringcalls`)
      .then((data) => {
        let res = dispatch({ type: UPDATE_DURING_CALLS_FORM, data: data });
        if (cb) {
          cb();
        }
        return res;
      })
      .catch((err) => console.error('There was an error getting the waiting areas', err.toString()));
  };
}

export function updateDuringCallDetail(waitingAreaId, duringCallDetail, cb) {
  return (dispatch) => {
    fc.put(`${window.APP.CONFIGURATION.VCCAPI}waitingareas/${waitingAreaId}/duringcalls`, {
      body: JSON.stringify(duringCallDetail),
    })
      .then((data) => {
        if (cb) {
          cb(true);
        }
        let successMessage = APP.LANGUAGE.DuringCallsModal.SuccessfulMessage;
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        console.error('There was an API error', err.toString());
        if (cb) {
          cb(false);
        }
      });
  };
}

export function updateDuringCallsForm(duringCallsFormModified) {
  return (dispatch) => {
    return dispatch({
      type: MODIFIED_DURING_CALLS_FORM,
      data: duringCallsFormModified,
    });
  };
}

export function checkIsRecordingAvailableOnPortal() {
  return (dispatch) => {
    fc.get(`${window.APP.CONFIGURATION.VCCAPI}portalSettings/IsRecordingAvailableOnPortal`)
      .then((data) => {
        let res = dispatch({
          type: UPDATE_IS_RECORDING_AVAILABLE_ON_PORTAL,
          data: data,
        });
        return res;
      })
      .catch((err) => console.error('There was an error getting the waiting areas', err.toString()));
  };
}

export function getCallQualityProfile() {
  return (dispatch) => {
    fc.get(`${window.APP.CONFIGURATION.VCCAPI}portalSettings/VideoCallQualityProfiles`)
      .then((data) => {
        let res = dispatch({ type: SET_CALL_QUALITY_PROFILE, data: data });
        return res;
      })
      .catch((err) => console.error('There was an error getting the waiting areas', err.toString()));
  };
}

////////////////////////////Operating Hours/////////////////////////////////////////////////////

export function getWaitingAreaOperatingHours(waitingAreaId, cb) {
  return (dispatch) => {
    dispatch({ type: GET_WAITING_AREA_OPERATING_HOURS });
    var apiPart = 'waitingareas/' + waitingAreaId + '/OperatingHours';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        let res = dispatch({
          type: GOT_WAITING_AREA_OPERATING_HOURS,
          data: data,
        });
        if (cb) cb();
        return res;
      })
      .catch((err) => console.error('There was an error getting the waiting areas Operating Hours', err.toString()));
  };
}

export function updateWaitingAreaOperatingHoursForm(updatedForm) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_WAITING_AREA_OPERATING_HOURS_FORM,
      data: updatedForm,
    });
  };
}

//UPDATED_WAITING_AREA_OPERATING_HOURS
export function updateWaitingAreaOperatingHours(waitingAreaId, operatingHoursForm, cb) {
  return (dispatch) => {
    let apiParam = 'waitingareas/' + waitingAreaId + '/OperatingHours';
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(operatingHoursForm),
    })
      .then((res) => {
        let successMessage = APP.LANGUAGE.WaitingAreaOperatingHours.SuccessSave;
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );

        if (cb) cb(true);
      })
      .catch((err) => {
        if (cb) cb(false);
        console.error('There was an API error', err.toString());
      });
  };
}

///////////////////////////End operating Hours/////////////////////////////////////////////////

////////////////////////////Local Video Operating Hours/////////////////////////////////////////////////////

export function getWaitingAreaLocalAccessHours(waitingAreaId, cb) {
  return (dispatch) => {
    dispatch({ type: GET_WAITING_AREA_LOCAL_ACCESS_HOURS });
    var apiPart = 'waitingareas/' + waitingAreaId + '/LocalTimezoneOperatingHours';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        let res = dispatch({
          type: GOT_WAITING_AREA_LOCAL_ACCESS_HOURS,
          data: data,
        });
        if (cb) cb();
        return res;
      })
      .catch((err) => console.error('There was an error getting the waiting areas Local Access Hours', err.toString()));
  };
}

export function updateWaitingAreaLocalAccessHoursForm(updatedForm) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_WAITING_AREA_LOCAL_ACCESS_HOURS_FORM,
      data: updatedForm,
    });
  };
}

//UPDATED_WAITING_AREA_LOCAL_ACCESS_HOURS
export function updateWaitingAreaLocalAccessHours(waitingAreaId, LocalAccessHoursForm, cb) {
  return (dispatch) => {
    let apiParam = 'waitingareas/' + waitingAreaId + '/LocalTimezoneOperatingHours';
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(LocalAccessHoursForm),
    })
      .then((res) => {
        let successMessage = APP.LANGUAGE.WaitingAreaLocalAccessHours.SuccessSave;
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );

        if (cb) cb(true);
      })
      .catch((err) => {
        if (cb) cb(false);
        console.error('There was an API error', err.toString());
      });
  };
}

///////////////////////////End Local Video operating Hours/////////////////////////////////////////////////
// Caller Entry point

// Get data for Caller Entry point dialog
export function getWaitingAreaCallerEntryPoint(waitingAreaId, cb) {
  return (dispatch) => {
    fc.get(`${window.APP.CONFIGURATION.VCCAPI}waitingareas/${waitingAreaId}/CallerEntryPoint`)
      .then((data) => {
        data.id = waitingAreaId;
        if (cb) {
          cb(data);
        }
      })
      .catch((err) =>
        console.error('There was an error getting the Caller Entry point for waiting areas', err.toString())
      );
  };
}

export function updateCallerEntryURL(waitingAreaId, payload, cb) {
  return (dispatch) => {
    fc.put(window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingAreaId + '/CallerEntryPoint', {
      body: JSON.stringify(payload),
    })
      .then((data) => {
        if (cb) cb(true);
        let callback = () => {
          let successMessage = APP.LANGUAGE.CallerEntryModal.SuccessfulMessage;
          dispatch(
            displayGlobalMessage({
              text: successMessage,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
              autoHide: true,
            })
          );
        };
        queueESEvents(
          ESEventTypes.APICall,
          `In updateCallerEntryURL: ${waitingAreaId}`,
          'eventType&apiURL',
          {
            apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingAreaId + '/calls',
            browserURL: window.location.href,
          },
          null,
          true,
          'info'
        );
        dispatch(getWaitingArea(waitingAreaId, callback));
      })
      .catch((err, response) => {
        if (err == 'WaitingAreaDuplicateShortUrl') {
          let urlInUseMsg = `The short URL extension "${payload.shortUrl}" is already in use.`;
          dispatch(
            displayGlobalMessage({
              text: urlInUseMsg,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: false,
              apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingAreaId + '/CallerEntryPoint',
              browserURL: window.location.href,
            })
          );
        }
        if (cb) cb(false, err); //TODO: should use organisation specific reset fetching flag
        console.error('There was an API error', err.toString());
      });
  };
}

export function updateCallerEntryForm(beforeCallsFormModified) {
  return (dispatch) => {
    return dispatch({
      type: MODIFIED_CALLER_ENTRY_POINT_FORM,
      data: beforeCallsFormModified,
    });
  };
}

export function updateCallerEntryPointForm(callerEntryPointInfo) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_CALLER_ENTRY_POINT_FORM,
      data: callerEntryPointInfo,
    });
  };
}

export function callerEntryPointUrlInUse(isInUse) {
  return (dispatch) => {
    return dispatch({ type: CALLER_ENTRY_POINT_URL_IN_USE, data: isInUse });
  };
}

export function sendEmailInstructions(waitingAreaId) {
  return (dispatch) => {
    fc.post(window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingAreaId + '/emailInstructions')
      .then((data) => {
        let successMessage = APP.LANGUAGE.CallerEntryModal.SuccessfulMessageForSendingInstructionsEmail;
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, response) => {
        console.error('There was an API error', err.toString());
      });
  };
}

// After calls
export function getAfterCallsInfo(waitingAreaId, cb) {
  return (dispatch) => {
    fc.get(`${window.APP.CONFIGURATION.VCCAPI}waitingareas/${waitingAreaId}/aftercalls`)
      .then((data) => {
        let res = dispatch({ type: GOT_WAITING_AREA_AFTER_CALLS, data: data });
        if (cb) {
          cb();
        }
        return res;
      })
      .catch((err) => console.error('There was an error getting the waiting areas', err.toString()));
  };
}

export function updateAfterCallDetail(waitingAreaId, afterCallDetail, cb) {
  return (dispatch) => {
    // Add check and see which option should be sent
    let postCallOption = afterCallDetail.postCallOption;
    let callerGuestUrl = afterCallDetail.callerGuestUrl == null ? '' : afterCallDetail.callerGuestUrl;
    let callProviderUrl = afterCallDetail.callProviderUrl == null ? '' : afterCallDetail.callProviderUrl;
    let postCallUrl = afterCallDetail.postCallUrl == null ? '' : afterCallDetail.postCallUrl;
    if (afterCallDetail.postCallOption === 1 && afterCallDetail.postCallUrl == '') {
      postCallOption = 0;
    }
    if (afterCallDetail.postCallOption === 2) {
      if (afterCallDetail.callProviderUrl == '' && afterCallDetail.callerGuestUrl == '') {
        postCallOption = 0;
      }
    }

    let newAfterCallDetail = {
      postCallOption: postCallOption,
      postCallUrl: postCallUrl,
      callProviderUrl: callProviderUrl,
      callerGuestUrl: callerGuestUrl,
    };

    fc.put(`${window.APP.CONFIGURATION.VCCAPI}waitingareas/${waitingAreaId}/updateaftercalls`, {
      body: JSON.stringify(newAfterCallDetail),
    })
      .then((data) => {
        if (cb) {
          cb(false);
        }
        let successMessage = APP.LANGUAGE.WaitingAreaAfterCalls.SuccessfulMessage;
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        console.error('There was an API error', err.toString());
        if (cb) {
          cb(true);
        }
      });
  };
}

export function updateAfterCallsForm(afterCallsFormModified) {
  return (dispatch) => {
    return dispatch({
      type: MODIFIED_AFTER_CALLS_FORM,
      data: afterCallsFormModified,
    });
  };
}

////////////////////////////Logo Pause Image/////////////////////////////////////////////////////

export function getWaitingAreaLogoPauseImage(waitingAreaId, cb) {
  return (dispatch) => {
    dispatch({ type: GET_WAITING_AREA_LOGO_PAUSE_IMAGE });
    var apiPart = 'waitingareas/' + waitingAreaId + '/imagesInfo';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        let res = dispatch({
          type: GOT_WAITING_AREA_LOGO_PAUSE_IMAGE,
          data: data,
        });
        if (cb) cb();
        return res;
      })
      .catch((err) => console.error('There was an error getting the waiting areas Logo Pause Image', err.toString()));
  };
}

export function updateWaitingAreaLogoPauseImageForm(updatedForm) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_WAITING_AREA_LOGO_PAUSE_IMAGE_FORM,
      data: updatedForm,
    });
  };
}

//UPDATED_WAITING_AREA_LOGO_PAUSE_IMAGE
export function updateWaitingAreaLogoPauseImage(
  waitingAreaId,
  logoImage,
  pauseImage,
  isLogoDefaultSelected,
  isPausedDefaultSelected,
  cb
) {
  return (dispatch) => {
    let apiParam = 'waitingareas/' + waitingAreaId + '/UpdateImagesInfo';
    dispatch({ type: UPDATE_WAITING_AREA_LOGO_PAUSE_IMAGE });
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify({
        logoBase64: logoImage,
        cameraDisabledBase64: pauseImage,
        isDefaultLogoSelected: isLogoDefaultSelected,
        isDefaultPauseImageFlag: isPausedDefaultSelected,
      }),
    })
      .then((res) => {
        let successMessage = APP.LANGUAGE.WaitingAreaLogoPauseImage.SuccessSave;
        dispatch({ type: UPDATED_WAITING_AREA_LOGO_PAUSE_IMAGE });
        dispatch(showWaitingAreaLogoPauseImageModal(false));
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );

        if (cb) cb(true);
      })
      .catch((err) => {
        if (cb) cb(false);
        dispatch({ type: UPDATED_WAITING_AREA_LOGO_PAUSE_IMAGE });
        console.error('There was an API error', err.toString());
      });
  };
}

////////////////////////////End Logo Pause Image/////////////////////////////////////////////////

/* Manage avaible role names */
export function getAvailableRoles(waitingAreaId) {
  return (dispatch) => {
    let apiPath = 'waitingareas/' + waitingAreaId + '/Roles';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPath)
      .then((data) => {
        return dispatch({
          type: GOT_AVAILABLE_ROLES_FOR_WAITING_AREA,
          data: data,
        });
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
      });
  };
}

/* Manage roles For users list */
export function updateSelectedUser(userId, cb) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SELECTED_USER_FOR_MANAGEMENT, data: userId });
    if (cb) cb();
  };
}

export function setManageRoleForm(rolesArray) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_ROLES_FOR_SELECTED_USER_IN_MANAGE_USERS_PAGE,
      data: rolesArray,
    });
  };
}

export function selectRoleAddUsersForm(roleId) {
  return (dispatch) => {
    return dispatch({
      type: ADD_USERS_FORM.SELECT_ROLE,
      data: roleId,
    });
  };
}

export function unSelectRoleAddUsersForm(roleId) {
  return (dispatch) => {
    return dispatch({
      type: ADD_USERS_FORM.UNSELECT_ROLE,
      data: roleId,
    });
  };
}

export function updateMessageAddUsersForm(message) {
  return (dispatch) => {
    return dispatch({
      type: ADD_USERS_FORM.UPDATE_MESSAGE,
      data: message,
    });
  };
}

export function clearAddUsersForm() {
  return (dispatch) => {
    return dispatch({
      type: ADD_USERS_FORM.CLEAR_FORM,
    });
  };
}

export function addUsersToWaitingArea(waitingArea, model, cb) {
  return (dispatch) => {
    // Update UI to show adding in progress
    dispatch({
      type: ADD_USERS_FORM.ADDING_USERS_TO_WAITING_AREA,
      data: waitingArea.id,
    });

    // Call VCC API
    const apiParam = 'waitingareas/' + waitingArea.id + '/addusers';
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(model),
    })
      .then((res) => {
        let cbForGetUsers = () => {
          // show success message
          const totalUsersAdded = model.userInvites.length + model.emailInvites.length;
          const successMessage =
            totalUsersAdded > 1
              ? APP.LANGUAGE.WaitingAreaAddUsersModal.MultipleUserAddedSuccess.replace(
                  '##entityName##',
                  waitingArea.name
                )
              : APP.LANGUAGE.WaitingAreaAddUsersModal.SingleUserAddedSuccess.replace(
                  '##entityName##',
                  waitingArea.name
                );

          dispatch(
            displayGlobalMessage({
              text: successMessage,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
              autoHide: true,
            })
          );

          // udpate redux state
          dispatch({
            type: ADD_USERS_FORM.CLEAR_FORM,
          });

          dispatch({
            type: SEARCH_SELECT_USERS_FORM.CLEAR_FORM,
          });
          if (cb) cb(res);
          dispatch(showHideWaitingAreaAddUsersModal(false));
        };

        // re-fetch the waiting area users list
        dispatch(getWaitingAreaUsers(waitingArea.id, cbForGetUsers));
      })
      .catch((err) => {
        if (cb) cb();
        console.error('There was an API error', err.toString());
      });
  };
}

export function resendInvitionToWaitingArea(waitingArea, user) {
  return (dispatch) => {
    // Call VCC API
    const apiParam = 'waitingareas/' + waitingArea.id + '/resendinvitation/' + user.id;
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((res) => {
        let cbForGetUsers = () => {
          // show success message
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.WaitingAreaUserActionMenu.ResendInviteSuccessMessage,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
              autoHide: true,
            })
          );
        };

        // re-fetch the waiting area users list
        dispatch(getWaitingAreaUsers(waitingArea.id, cbForGetUsers));
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
      });
  };
}

export function cancelInvitionToWaitingArea(waitingArea, user) {
  return (dispatch) => {
    // Call VCC API
    const apiParam = 'waitingareas/' + waitingArea.id + '/cancelinvitation/' + user.id;
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((res) => {
        let cbForGetUsers = () => {
          // show success message
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.WaitingAreaUserActionMenu.CancelInviteSuccessMessage,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
              autoHide: true,
            })
          );
        };

        // re-fetch the waiting area users list
        dispatch(getWaitingAreaUsers(waitingArea.id, cbForGetUsers));
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
      });
  };
}

////////////////Self provision invite start///////////////
export function inviteSelfProvision(invitedUser, isTicked, cb) {
  return (dispatch) => {
    fc.post(window.APP.CONFIGURATION.VCCAPI + 'waitingareas/inviteUserForSelfProvisioning', {
      body: JSON.stringify({ email: invitedUser.email, isTicked: isTicked }),
    })
      .then((response) => {
        if (cb) cb(true, response, invitedUser);
        var successMessage = APP.LANGUAGE.WaitingAreaSelfProvision.SuccessSendMessage;
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        console.error('There was an API error', err.toString());
        if (cb) cb(false, null);
      });
  };
}
export function getLastInvite(email, cb) {
  return (dispatch) => {
    fc.post(window.APP.CONFIGURATION.VCCAPI + 'waitingareas/getLastInvite/', { body: JSON.stringify({ email: email }) })
      .then((response) => {
        if (cb) cb(true, response);
      })
      .catch((err, resp) => {
        console.error('There was an API error', err.toString());
        if (cb) cb(false, null);
      });
  };
}
////////////////End Self provision invite end/////////////////

///////////////////////////////////////Create  WA, ORG and user (if needed)////////////

export function validateSelfProvisionTokenIsValid(token, cb) {
  return (dispatch) => {
    // Call VCC API
    const apiParam = 'waitingareas/validateSelfProvisionToken/' + token + '/';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((res) => {
        if (cb) {
          cb(true, res);
        }
      })
      .catch((err) => {
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.SelfProvisionCreateWA.InvalidToken,
            visible: true,
            messageType: 'Bad',
          })
        );
        cb(false);
        console.error('There was an API error', err.toString());
      });
  };
}

export function setWASelfProvisionForm(userWAForm) {
  return (dispatch) => {
    dispatch({
      type: SET_WA_SELF_PROVISION_FORM,
      data: userWAForm,
    });
  };
}

export function setWASelfProvisionFormTrim() {
  return (dispatch) => {
    dispatch({
      type: SET_WA_SELF_PROVISION_FORM_TRIM,
    });
  };
}

export function resetWASelfProvisionForm() {
  return (dispatch) => {
    dispatch({
      type: RESET_WA_SELF_PROVISION_FORM,
    });
  };
}
////We use the same API call to register User and WA/org

export function createSelfProvisionWA(selfProvisionCreateForm, cb) {
  return (dispatch) => {
    // Call VCC API
    const apiParam = 'waitingareas/CreateSelfProvisionWA';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(selfProvisionCreateForm),
    })
      .then((res) => {
        let successMessage = APP.LANGUAGE.SelfProvisionCreateWA.SelfProvisionWACreated.replace(
          '##WaitingAreaName##',
          selfProvisionCreateForm.waitingAreaName
        );
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        if (cb) {
          cb(true, res);
        }
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        cb(false, null, err);
      });
  };
}

///////////////////////////////////////END Create  WA, ORG and user (if needed)////////////
//CREATE WA - via dialog from org
export function setCreateWAForm(userWAForm) {
  return (dispatch) => {
    dispatch({
      type: SET_CREATE_WA_FORM,
      data: userWAForm,
    });
  };
}
export function setCreateWAFormTrim() {
  return (dispatch) => {
    dispatch({
      type: SET_CREATE_WA_FORM_TRIM,
    });
  };
}

export function resetCreateWAForm() {
  return (dispatch) => {
    dispatch({
      type: RESET_CREATE_WA_FORM,
    });
  };
}
export function createWaitingArea(createWAForm, cb) {
  return (dispatch) => {
    // Call VCC API
    const apiParam = 'waitingareas/createWaitingArea';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(createWAForm),
    })
      .then((res) => {
        let successMessage = APP.LANGUAGE.SelfProvisionCreateWA.SelfProvisionWACreated.replace(
          '##WaitingAreaName##',
          createWAForm.waitingAreaName
        );
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        if (cb) {
          cb(true, res);
        }
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        cb(false, null, err);
      });
  };
}
//END CREATE WA - via dialog
// Support contact
export function getSupportContactInfo(waitingAreaId, cb) {
  return (dispatch) => {
    const apiParam = 'waitingareas/' + waitingAreaId + '/WaitingAreaSupportSetting';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((data) => {
        dispatch({ type: SUPPORT_CONTACT.GOT_INFO, data: data });
        if (cb) cb();
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
      });
  };
}

export function changeSupportContact(supportcontactForm) {
  return (dispatch) => {
    dispatch({
      type: SUPPORT_CONTACT.CHANGE_SUPPORT_CONTACT_INFO,
      data: supportcontactForm,
    });
  };
}

export function updateSupportContact(waitingAreaId, supportcontactForm, cb) {
  return (dispatch) => {
    let payload = {
      supportName: supportcontactForm.supportName,
      supportEmail: supportcontactForm.supportEmail,
      supportPhone: supportcontactForm.supportPhone,
      supportWebsite: supportcontactForm.supportWebsite,
      moreAssistance: supportcontactForm.moreAssistance,
    };
    const apiParam = 'waitingareas/' + waitingAreaId + '/WaitingAreaSupportSetting';
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(payload),
    })
      .then((data) => {
        if (cb) cb(false);
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.SupportContactModal.SuccessfulMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        if (cb) {
          cb(true);
        }
      });
  };
}

// Information for Callers
export function getWaitingAreaInfoForCallers(waitingAreaId, cb) {
  return (dispatch) => {
    const apiParam = 'waitingareas/' + waitingAreaId + '/WaitingAreaCallerInformation';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((data) => {
        dispatch({
          type: GOT_WAITING_AREA_INFORMATION_FOR_CALLERS,
          data: data,
        });
        if (cb) cb();
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
      });
  };
}

export function changeWaitingAreaInfoForCallers(informationForCallersForm) {
  return (dispatch) => {
    dispatch({
      type: CHANGE_WAITING_AREA_INFORMATION_FOR_CALLERS,
      data: informationForCallersForm,
    });
  };
}

export function WaitingAreaInfoForCallersFileNotAccepted(uploadFileNotAccepted) {
  return (dispatch) => {
    dispatch({
      type: WAITING_AREA_INFORMATION_FILE_SIZE_EXCEED,
      data: uploadFileNotAccepted,
    });
  };
}

export function saveWaitingAreaInfoForCallers(waitingAreaId, informationForCallersForm, cb) {
  return (dispatch) => {
    const apiParam = 'waitingareas/' + waitingAreaId + '/WaitingAreaCallerInformation';
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(informationForCallersForm),
    })
      .then((data) => {
        if (cb) cb(true);
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        if (cb) {
          cb(false);
        }
      });
  };
}

export function downloadPILFile(waitingAreaId, updateComponentState) {
  let apiPart = 'waitingareas/' + waitingAreaId + '/DownloadPatientInfoLeaflet';
  let url = window.APP.CONFIGURATION.VCCAPI + apiPart;

  fetch(url, { headers: getAuthHeaders(), method: 'GET' })
    .then((res) => {
      let filename = res.headers.get('aafilename') || 'Leaflet.pdf';
      res
        .blob()
        .then((blob) => {
          let pdfUrl = URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.setAttribute('href', pdfUrl);
          link.setAttribute('download', filename.toString());
          link.click();
        })
        .finally(() => {
          if (updateComponentState) {
            updateComponentState();
          }
        });
    })
    .catch((err) => {
      console.error('There was an API error', err.toString());
      if (updateComponentState) {
        updateComponentState();
      }
    });
}

// Manage Tags
export function updateSelectedTag(tagObject, cb) {
  return (dispatch) => {
    dispatch({
      type: WAITING_AREA_TAGS.UPDATE_SELECTED_TAG_FOR_MANAGEMENT,
      data: tagObject,
    });
    if (cb) cb();
  };
}

export function deleteTagFromWA(waitingAreaId, deleteTagObject, cb) {
  return (dispatch) => {
    const apiParam = 'tags/' + deleteTagObject.tagId + '/unassign/' + waitingAreaId;
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((data) => {
        if (cb) cb(false);
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        if (cb) {
          cb(true);
        }
      });
  };
}

export function getAvailableTagsByNetworkId(waitingAreaId, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({
        type: WAITING_AREA_TAGS.ERROR_GETTING_AVAILABLE_TAGS_BY_NETWORKID,
      });
    };

    const apiPart = 'tags/network/' + waitingAreaId + '/availabletags';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        dispatch({
          type: WAITING_AREA_TAGS.GOT_AVAILABLE_TAGS_BY_NETWORKID,
          data: {
            availableTags: data,
            waitingAreaId: waitingAreaId,
          },
        });
        if (cb) cb(data);
      })
      .catch((err) => {
        (err) => errorCallback(err);
      });
  };
}

export function saveEditTags(waitingAreaId, editedTagObject, cb) {
  return (dispatch) => {
    const apiPart = 'tags/network/' + waitingAreaId + '/update';
    let payload = {
      tagId: editedTagObject.tagId,
      addedValues: editedTagObject.addedValues,
      removedValues: editedTagObject.removedValues,
    };
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(payload),
    })
      .then((data) => {
        if (cb) cb(false);
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        if (cb) {
          cb(true);
        }
      });
  };
}

export function saveAssignTags(waitingAreaId, addedTagObject, cb) {
  let errorHandler = (err) => {
    console.error('There was an API error', err.toString());
    if (cb) {
      cb(true);
    }
  };
  return (dispatch) => {
    const apiPart = 'tags/network/' + waitingAreaId + '/assign';
    let payload = {
      tagId: addedTagObject.tagId,
      addedValues: addedTagObject.addedValues,
    };
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(payload),
    })
      .then((data) => {
        if (cb) cb(false);
      })
      .catch((err) => {
        errorHandler(err);
      });
  };
}

export function updateAsssignedValuesByTagId(tagValuesObject, cb) {
  return (dispatch) => {
    dispatch({
      type: WAITING_AREA_TAGS.UPDATE_ASSIGN_TAG_VALUES_FORM,
      data: tagValuesObject,
    });
    if (cb) cb();
  };
}

export function getAvailableTagsByTagId(tagId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      let errorCallback = (response) => {
        console.error('ERROR', response);
        dispatch({
          type: WAITING_AREA_TAGS.ERROR_GETTING_AVAILABLE_TAGS_BY_TAGID,
        });
        reject('ERROR');
      };

      const apiPart = 'tags/' + tagId;
      fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
        .then((data) => {
          dispatch({
            type: WAITING_AREA_TAGS.UPDATE_SELECTED_TAG_FOR_MANAGEMENT,
            data: {
              tagId: data.tagId,
              tagName: data.tagName,
              description: data.description,
              canMultiSelect: data.canMultiSelect,
              availableTagValues: data.tagValues,
            },
          });
          resolve(dispatch);
        })
        .catch((err) => {
          (err) => errorCallback(err);
        });
    });
  };
}

export function clearTempAssignTagsObject() {
  return (dispatch) => {
    dispatch({ type: WAITING_AREA_TAGS.CLEAR_TEMP_ASSIGN_TAGS_OBJECT });
  };
}

export function getWaitingAreaTags(waitingAreaId, cb) {
  return (dispatch) => {
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: WAITING_AREA_TAGS.ERROR_GETTING_TAGS });
    };

    const apiPart = 'tags/network/' + waitingAreaId;

    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        if (cb) cb();
        let res = dispatch({
          type: WAITING_AREA_TAGS.GOT_TAGS,
          data: {
            tags: data,
            waitingAreaId: waitingAreaId,
          },
        });
        return res;
      })
      .catch((err) => {
        errorCallback(err);
      });
  };
}

export function updateWaitingAreaTagSearch(searchTerm) {
  return (dispatch) => {
    dispatch({ type: WAITING_AREA_TAGS.UPDATE_SEARCH_TERM, data: searchTerm });
  };
}

export function updateWaitingAreasPermission(data) {
  return (dispatch) => {
    dispatch({ type: UPDATE_WAITING_AREAS_PERMISSION, data });
  };
}

export function showAdvancedMenu(hideOrShow) {
  return (dispatch) => {
    dispatch({ type: SHOW_ADVANCED_MENU, data: hideOrShow });
  };
}

// Update selected participant details in PiWA
export function updateSelectedParticipantInWAForm(selectedParticipantForm) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_SELECTED_PARTICIPANT_FORM_IN_WA,
      data: selectedParticipantForm,
    });
  };
}

// Update selected call room
export function updateSelectedVideoCallRoom(room, cb) {
  return (dispatch) => {
    // In order to close any unexpected open modal for call activities
    dispatch(showShowCallHistoryModal(false));
    dispatch({ type: UPDATE_SELECTED_VIDEO_CALL_ROOM, data: room });
    if (cb) cb();
  };
}

// Update selected video call room id
export function updateSelectedVideoCallRoomId(roomId, cb) {
  return (dispatch) => {
    if (cb) cb();
    dispatch({ type: UPDATE_SELECTED_VIDEO_CALL_ROOM_ID, data: roomId });
  };
}

// Deactivate Waiting Area
export function deleteWaitingArea(waitingAreaId, waitingAreaName, cb) {
  return (dispatch) => {
    const apiPart = 'waitingareas/' + waitingAreaId + '/Deactivate';

    fc.put(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        if (cb) cb(false);
        let res = dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.DeleteWaitingAreaModal.SuccessfulMessage.replace('##waitingarea##', waitingAreaName),
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        return res;
      })
      .catch((err) => {
        // ConsultNowCallsPending
        if (err === 'ConsultNowCallsPending')
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.DeleteWaitingAreaModal.UnableToDeleteWA,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: true,
            })
          );
        if (cb) cb(true);
      });
  };
}

// Get waiting area history
export function getWaitingAreaCallHistory(waitingAreaId, roomId, cb) {
  return (dispatch) => {
    const apiPart = `waitingareas/${waitingAreaId}/callshistory/${roomId}`;

    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        dispatch({
          type: UPDATE_WA_CALL_HISTORY,
          data: { roomId: roomId, info: data },
        });
        if (cb) cb();
      })
      .catch((err) => {
        console.error('ERROR', err);
        if (cb) cb(true);
      });
  };
}
// Get waiting area authTicketId
export function createVidyoRoomAuthTicket(waitingAreaId, roomId, cb) {
  return (dispatch) => {
    const apiPart = 'waitingareas/roomAuthTicket';
    var data = { waitingAreaId, roomId };

    fc.post(window.APP.CONFIGURATION.VCCAPI + 'waitingareas/VidyoRoomAuthTicket', {
      body: JSON.stringify(data),
    })
      .then((data) => {
        dispatch({
          type: SET_AUTH_TICKET,
          data: {
            waitingAreaId: waitingAreaId,
            roomId: roomId,
            authTicket: data,
          },
        });
        if (cb) cb(true, data);
      })
      .catch((err, resp) => {
        cb(false);
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.ViewOneWaitingArea.JoinCallError,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: false,
            apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/VidyoRoomAuthTicket',
            browserURL: window.location.href,
          })
        );
        console.error('There was an error creating Auth Ticket', err.toString());
      });
  };
}
// Update if the WA is open or not
export function updateOpenOrClosedForWA(waitingAreaId, isOpen) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_WA_IS_OPEN_OR_CLOSED,
      data: {
        waitingAreaId: waitingAreaId,
        isOpen: isOpen,
      },
    });
  };
}

// Get waiting area participants and rooms' details
export function getParticipantsRoomsInWA(waitingAreaId, cb, networkTypeId) {
  return (dispatch) => {
    const apiPart = 'waitingareas/' + waitingAreaId + '/vidyoRooms';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        dispatch({
          type:
            networkTypeId === NetworkTypes.GroupConsultation
              ? SET_WAITING_AREA_ROOM_AND_PARTICIPANTS_GC
              : SET_WAITING_AREA_ROOM_AND_PARTICIPANTS,
          data: {
            waitingAreaId: waitingAreaId,
            roomsDetail: data,
          },
        });
        if (cb) cb(true);
      })
      .catch((err, resp) => {
        if (cb) cb(false);
        console.error('ERROR', err);
      });
  };
}

export function getCallSummaryByWAId(waitingAreaId, cb) {
  return (dispatch) => {
    const apiPart = 'waitingareas/' + waitingAreaId + '/callSummary';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        dispatch({
          type: SET_CALL_SUMMARY_BY_ID,
          data: {
            waitingAreaId: waitingAreaId,
            callSummary: data,
          },
        });
        if (cb) cb(true);
      })
      .catch((err, resp) => {
        if (cb) cb(false);
        console.error('ERROR', err);
      });
  };
}

// Send invite email by WA id
export function getWAURLEmailTemplate(waitingAreaId, cb) {
  return (dispatch) => {
    const apiPart = 'waitingareas/' + waitingAreaId + '/shareWaitingAreaEntryPointByEmail';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        dispatch({
          type: SET_WA_URL_EMAIL_TEMPLATE,
          data: data,
        });

        if (cb) cb(true, data);
      })
      .catch((err, resp) => {
        if (cb) cb(false);
        console.error('ERROR', err);
      });
  };
}

export function getWAURLTextTemplate(waitingAreaId, cb) {
  return (dispatch) => {
    const apiPart = 'waitingareas/' + waitingAreaId + '/shareWaitingAreaEntryPointBySms';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        dispatch({
          type: SET_WA_URL_TEXT_TEMPLATE,
          data: data,
        });
        if (cb) cb(true, data);
      })
      .catch((err, resp) => {
        if (cb) cb(false);
        console.error('ERROR', err);
      });
  };
}

export function sendInviteEmailByWAId(waitingAreaId, payload, cb) {
  const apiPart = 'waitingareas/' + waitingAreaId + '/shareWaitingAreaEntryPointByEmail';
  fc.post(window.APP.CONFIGURATION.VCCAPI + apiPart, {
    body: JSON.stringify(payload),
  })
    .then((data) => {
      if (cb) cb(true);
    })
    .catch((err, resp) => {
      if (cb) cb(false, err);
      console.error('ERROR', err);
    });
}

export function sendInviteSMSByWAId(waitingAreaId, payload, cb) {
  const apiPart = 'waitingareas/' + waitingAreaId + '/shareWaitingAreaEntryPointBySms';
  fc.post(window.APP.CONFIGURATION.VCCAPI + apiPart, {
    body: JSON.stringify(payload),
  })
    .then((data) => {
      if (cb) cb(true);
    })
    .catch((err, resp) => {
      if (cb) cb(false, err);
      console.error('ERROR', err);
    });
}

// Share waiting area link message
export function getWaitingAreaShareLinkMessage(waitingAreaId, cb) {
  return (dispatch) => {
    const apiParam = 'waitingareas/' + waitingAreaId + '/entryPointAdditionalMessageSettings';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((data) => {
        dispatch({
          type: GOT_WAITING_AREA_SHARE_LINK_MESSAGE,
          data: data,
        });
        if (cb) cb();
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
      });
  };
}

export function saveWAShareLinkMessage(waitingAreaId, payload, cb) {
  return (dispatch) => {
    const apiPart = 'waitingareas/' + waitingAreaId + '/entryPointAdditionalMessageSettings';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(payload),
    })
      .then((data) => {
        if (cb) cb(true);
      })
      .catch((err, resp) => {
        if (cb) cb(false, err);
        console.error('ERROR', err);
      });
  };
}

// Consult now Settings
export const saveConsultNowSettings = (waitingAreaId, payload) => (dispatch) =>
  new Promise((resolve, reject) => {
    const apiPart = 'waitingareas/' + waitingAreaId + '/consult_now';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(payload),
    })
      .then(() => {
        let successMessage = APP.LANGUAGE.ConsultNow.SuccessUpdateMessage;
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        resolve();
      })
      .catch((err) => {
        if (err == 'ConsultNowCallsPending') {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.ConsultNow.PendingFailedDisable,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: true,
            })
          );
        }
        // NoNetworkViewPermission
        if (err == 'NoNetworkViewPermission') {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.ConsultNow.NoNetworkViewPermission,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: false,
              gotItButtonText: APP.LANGUAGE.ShareLinkSharedText.Refresh,
              gotItCallBack: () => {
                window.location.reload();
              },
            })
          );
        }
        reject(err);
      });
  });

// save WA Audio Settings
export const saveWAAudioSettings = (waitingAreaId, payload) => (dispatch) =>
  new Promise((resolve, reject) => {
    const apiPart = 'waitingareas/' + waitingAreaId + '/recording';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(payload),
    })
      .then(() => {
        let successMessage = APP.LANGUAGE.Recording.SuccessUpdateMessage;
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        resolve();
      })
      .catch((err) => {
        // NoNetworkViewPermission
        if (err == 'NoNetworkViewPermission') {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.ConsultNow.NoNetworkViewPermission,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: false,
              gotItButtonText: APP.LANGUAGE.ShareLinkSharedText.Refresh,
              gotItCallBack: () => {
                window.location.reload();
              },
            })
          );
        }
        reject(err);
      });
  });
export function getWARecordingSetting(wid, cb) {
  return (dispatch) => {
    const apiPart = 'waitingareas/' + wid + '/isRecordingEnabled';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        if (cb) cb(data);
        dispatch({
          type: GOT_WARECORDING_SETTING_FEATURE,
          data: data,
        });
      })
      .catch((err, resp) => {
        if (cb) cb(false, err);
        console.error('ERROR', err);
      });
  };
}
// Get Consult Now initated calls
export function getConsultNowInitiatedCalls(waitingAreaId, cb) {
  return (dispatch) => {
    const apiPart = 'waitingareas/' + waitingAreaId + '/consult_now/initiated_calls';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        dispatch({
          type: GOT_CONSULT_NOW_INITIATED_CALLS,
          data: {
            waitingAreaId: waitingAreaId,
            initialedCalls: data,
          },
        });
        if (cb) cb(true, data);
      })
      .catch((err, resp) => {
        if (cb) cb(false, null, err);
        console.error('ERROR', err);
      });
  };
}

// Send Consult Now invitation
export function sendConsultNowInvitation(waitingAreaId, payload, cb) {
  return (dispatch) => {
    const apiPart = 'waitingareas/' + waitingAreaId + '/consult_now/caller';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(payload),
    })
      .then((data) => {
        if (cb) cb(true, data);
      })
      .catch((err, resp) => {
        if (err == 'AlreadyHasConsultNowLink' || err == 'IsAlreadyInCall') {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.SendConsultNowInvitation.AlreadyInCall,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: true,
            })
          );
        } else if (err == 'WAClosed') {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.SendConsultNowInvitation.WaitingAreaClosed,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: true,
            })
          );
        } else if (err == 'WASuspended') {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.SendConsultNowInvitation.WASuspended,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: true,
            })
          );
        } else if (err.trim() == 'NoNetworkAnswerPermission') {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.SendConsultNowInvitation.NoNetworkAnswerPermission,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: true,
            })
          );
        } else if (err == 'ConsultNowSMSNotSent') {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.ServerErrors.WaitingAreaShareEntryPointUrlSmsNotSent,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: true,
            })
          );
        }
        if (cb) cb(false, null, err);
        console.error('ERROR', err);
      });
  };
}

// This function is to store selected caller details (Consult Now ticket it, expiry time...) in Redux state
// so that Cancel invation / Extend time modal can use that data
export function updateSelectedConsultNowCaller(caller, cb) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_SELECTED_CONSULT_NOW_CALLER,
      data: caller,
    });
    if (cb) cb();
  };
}

export function cancelCNInvitationTicket(payload, cb) {
  return (dispatch) => {
    const apiPart = 'waitingareas/consult_now';
    fc.delete(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(payload),
    })
      .then((data) => {
        unSubscribPubnubChannels(['cn-' + payload.authTicketId]);
        if (cb) cb(true);
      })
      .catch((err, resp) => {
        if (err == 'ConsultNowAuthTicketExpired') {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.SendConsultNowInvitation.ConsultNowCallExpiredOnCancel,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: true,
            })
          );
        }
        if (cb) cb(false, err);
        console.error('ERROR', err);
      });
  };
}

export function resendCNInvitation(authTicketId, cb) {
  return (dispatch) => {
    const apiPart = 'waitingareas/consult_now/' + authTicketId + '/resend_invitation';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        if (cb) cb(true);
      })
      .catch((err, resp) => {
        if (err == 'ConsultNowAuthTicketExpired') {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.SendConsultNowInvitation.ConsultNowCallExpiredOnResend,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: true,
            })
          );
        }
        if (cb) cb(false, err);
        console.error('ERROR', err);
      });
  };
}

export function extendCNInvitationTicket(authTicketId, payload, cb) {
  return (dispatch) => {
    const apiPart = 'waitingareas/consult_now/' + authTicketId;
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiPart, {
      body: JSON.stringify(payload),
    })
      .then((data) => {
        if (cb) cb(true);
      })
      .catch((err, resp) => {
        if (err == 'ConsultNowExtendLimitReaching') {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.SendConsultNowInvitation.CallTimeLimit,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: true,
            })
          );
        } else if (err == 'ConsultNowAuthTicketExpired') {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.SendConsultNowInvitation.ConsultNowCallExpired,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: true,
            })
          );
        }
        if (cb) cb(false, err);
        console.error('ERROR', err);
      });
  };
}

export const setVidyoRoomIdForCN = (data, cnAuthTicket) => {
  return (dispatch, getState) => {
    let isModalOpen = getState().modalReducer && getState().modalReducer.showConsultNowInvitationModal;
    return dispatch({ type: SET_VIDYO_ROOM_ID_FOR_CONSULT_NOW, data, isModalOpen });
  };
};

// Get data for Create WA Dialog Settings
export function getWaitingAreaCreateSettings(orgNetworkId, cb) {
  return (dispatch) => {
    fc.get(`${window.APP.CONFIGURATION.VCCAPI}waitingareas/${orgNetworkId}/getWaitingAreaCreateSettings`)
      .then((data) => {
        if (cb) {
          var createWAModel = {
            isGroupConsultationFeatureEnabled: data.isGroupConsultationFeatureEnabled || false,
            networkTypeId: data.createWAStandardDefaultValue
              ? NetworkTypes.WaitingArea
              : data.createWAGroupConsultationDefaultValue
              ? NetworkTypes.GroupConsultation
              : 0,
          };
          cb(createWAModel);
        }
      })
      .catch((err) => console.error('There was an error getting the general info for waiting areas', err.toString()));
  };
}

///////////////////////////////////////////WA-GC-SETTINGS-[CHAT-FULLNAME]-CONTROLS////////////////////////////////////////////////////////////

// Get data for Waiting Area GC Setting
export function getGCWASettings(waitingAreaId, cb) {
  return (dispatch) => {
    const apiParam = 'waitingareas/' + waitingAreaId + '/getGCWASettings';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((data) => {
        dispatch({ type: GOT_GC_WAITING_AREA_SETTINGS, data: data });
        queueESEvents(
          ESEventTypes.APICall,
          `In getGCWASettings: ${waitingAreaId}`,
          'eventType&apiURL',
          {
            apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingAreaId + '/getGCWASettings',
            browserURL: window.location.href,
          },
          null,
          true,
          'info'
        );
        if (cb) cb();
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        queueESEvents(ESEventTypes.GCSettingsAPIError, err.toString());
        dispatch(defaultGCWAErrors(err));
      });
  };
}

// Update Form for gc settings
export function updateGcWASettingForm(gcWASettingFormModified) {
  return (dispatch) => {
    return dispatch({
      type: MODIFIED_GC_WA_SETTING_FORM,
      data: gcWASettingFormModified,
    });
  };
}
//Update call to set gc setting form dataToSave
export function updateGCSettingCall(waitingAreaId, payload, cb) {
  return (dispatch) => {
    fc.post(`${window.APP.CONFIGURATION.VCCAPI}waitingareas/${waitingAreaId}/saveGCWASettings`, {
      body: JSON.stringify(payload),
    })
      .then((data) => {
        queueESEvents(
          ESEventTypes.GCSettingsWAUpdate,
          `In updateGCSettingCall: ${JSON.stringify(payload)}`,
          'eventType&apiURL',
          {
            apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + waitingAreaId + '/saveGCWASettings',
            browserURL: window.location.href,
            waitingAreaId: waitingAreaId,
          },
          null,
          true,
          'info'
        );
        if (cb) {
          cb();
        }
        let successMessage = APP.LANGUAGE.GCSettings.SuccessUpdateMessage;
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        console.error('There was an API error', err.toString());
        queueESEvents(ESEventTypes.GCSettingsUpdateAPIError, err.toString());
        dispatch(defaultGCWAErrors(err));
        if (cb) {
          cb();
        }
      });
  };
}
export function defaultGCWAErrors(err) {
  return (dispatch) => {
    if (err == 'Invalid request') {
      dispatch(
        displayGlobalMessage({
          text: APP.LANGUAGE.GCSettings.InvalidRequest,
          visible: true,
          messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
          autoHide: true,
        })
      );
    }
    if (err == 'FeatureNotAllowed') {
      dispatch(
        displayGlobalMessage({
          text: APP.LANGUAGE.GCSettings.FeatureNotAllowed,
          visible: true,
          messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
          autoHide: true,
        })
      );
    }
    if (err == 'OrgGCSettingNotAllowed') {
      dispatch(
        displayGlobalMessage({
          text: APP.LANGUAGE.GCSettings.OrgGCSettingNotAllowed,
          visible: true,
          messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
          autoHide: true,
        })
      );
    }
    if (err == 'AccessDenied') {
      dispatch(
        displayGlobalMessage({
          text: APP.LANGUAGE.GCSettings.AccessDenied,
          visible: true,
          messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
          autoHide: true,
        })
      );
    }
    if (err == 'GCWaitingAreaCallsInProgress ') {
      console.log(`here to check GCWaitingAreaCallsInProgress`);
      dispatch(
        displayGlobalMessage({
          text: APP.LANGUAGE.GCSettings.GCWaitingAreaCallsInProgress,
          visible: true,
          messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
          autoHide: true,
        })
      );
    }
    if (err == 'NetworkNotFound') {
      dispatch(
        displayGlobalMessage({
          text: APP.LANGUAGE.GCSettings.NetworkNotFound,
          visible: true,
          messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
          autoHide: true,
        })
      );
    }
  };
}
